import React from 'react';
import { useSiteData, DataContextProps } from '@context';
import FooterNavigation from './footer-navigation';
import LegalNavigation from './footer-legal-navigation';
import { Script } from 'gatsby';

/**
 * Footer
 */
const Footer = (): JSX.Element | null => {
  const { siteData }: DataContextProps = useSiteData();

  if (!siteData) {
    return null;
  }

  const { translations, currentLocale } = siteData;

  /**
   * Render.
   */
  if (translations) {
    return (
      <footer>
        <div className="container large">
          <div className="footer-container">
            <div className="safety">
              <FooterNavigation />
              <h2>{translations.safety}</h2>
              {currentLocale === 'en' ? (
                <p>
                  Important Safety Notice: Varian products used to treat cancer
                  and other conditions pose the risk of side effects, which can
                  vary based on the treatment modality and part of the body
                  being treated. Safety information regarding risks associated
                  with the use of our products can be found on our{' '}
                  <a
                    href="https://cancercare.siemens-healthineers.com/about-us/legal-information/intended-use-summary-important-safety-information"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Safety Information page.
                  </a>
                </p>
              ) : (
                <p>{translations.safety_description}</p>
              )}
              <p>
                © Varian Medical Systems, Inc. - A Siemens Healthineers Company,
                2026
                {new Date().getFullYear() > 2026
                  ? ` - ${new Date().getFullYear()}`
                  : ''}
                .
              </p>
              <Script
                strategy="idle"
                id="usercentrics-cmp"
                async
                data-ruleset-id="4TfXQkelOfjFym"
                src="https://web.cmp.usercentrics.eu/ui/loader.js"
              />
            </div>
            <FooterNavigation />
          </div>
          <LegalNavigation />
        </div>
      </footer>
    );
  }

  return null;
};
export default Footer;
